import { IncomingMessage } from 'http'

import { Cart } from './types'
import { createClient } from '@services/api'

export function fetchCart(req?: IncomingMessage) {
  return async ({ queryKey }) => {
    const [, params] = queryKey
    const { data } = await createClient(req).get('/cart', {
      params: {
        promoCode: params?.promoCode ?? undefined,
        partner: params?.partner ?? undefined,
        affiliate: params?.affiliate ?? undefined
      }
    })

    return data as Cart
  }
}
